// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./inc/style/screen.scss
// module id = 17
// module chunks = 0